import _jsx from "@babel/runtime/helpers/jsx";
var _Text;
import React from 'react';
import { Box, Button, Text } from 'reaxl';
import clsx from 'clsx';
function ActiveDealIndicator(_ref) {
  let {
    orientation,
    onActiveDealDetailsClick,
    onCheckStatusClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: clsx({
      'padding-left-3': orientation === 'portrait'
    }, 'padding-vertical-3 padding-right-3')
  }, void 0, /*#__PURE__*/_jsx(Box, {
    borderColor: "brand-tertiary",
    backgroundColor: "brand-primary",
    "data-cmp": "listing-activeDealBadge",
    className: "text-center"
  }, void 0, _Text || (_Text = /*#__PURE__*/_jsx(Text, {
    color: "primary",
    weight: "bold",
    size: 400,
    componentClass: "div"
  }, void 0, "You've submitted an offer.")), /*#__PURE__*/_jsx("div", {
    className: "text-size-200 display-flex justify-content-center gap-2"
  }, void 0, /*#__PURE__*/_jsx(Button, {
    bsStyle: "text",
    onClick: onCheckStatusClick
  }, void 0, "Check Status"), "|", /*#__PURE__*/_jsx(Button, {
    bsStyle: "text",
    onClick: onActiveDealDetailsClick
  }, void 0, "See Vehicle Details"))));
}
export default ActiveDealIndicator;